import Home from './../pages/Home';
import Partner from './../partners/Partner';
import PartnerRegister from './../partners/PartnerRegister';
import PartnerList from './../partners/PartnerList';
import PartnerListModeration from './../partners/PartnerListModeration';
import BranchOffices from './../catalogs/BranchOffices';
import ChangeRecord from './../pages/ChangeRecord';
import GroupList from './../groups/GroupList';
import GroupListAutorization from './../groups/GroupListAutorization';
import GroupRegister from './../groups/GroupRegister';
import GroupRegisterWizard from './../groups/GroupRegisterWizard';
import Group from './../groups/Group';
import GroupListPayment from './../groups/GroupListPayment';
import EmployeeRegister from './../employees/EmployeeRegister';
import Employee from './../employees/Employee';
import EmployeeList from './../employees/EmployeeList';
import Configuration from '../system/Configuration';
import user from './../../settings/user';
import _ from 'underscore';
import GroupListAuthorized from '../groups/GroupListAuthorized';
import DocumentPaymentControl from '../documents/DocumentPaymentControl';
import DocumentCheckPolicy from '../documents/DocumentCheckPolicy';
import DocumentVarius from '../documents/DocumentVarius';
import GroupListPaymentReport from '../groups/GroupListPaymentReport';
import GroupRequisitions from '../groups/GroupRequisitions';
import GroupListCheck from '../groups/GroupListCheck';
import GroupListCheckRequisition from '../groups/GroupListCheckRequisition';
import GroupRequisitionPayments from '../groups/GroupRequisitionPayments';
import RequisitionDetails from '../groups/RequisitionDetails/RequisitionDetails';
import AccountingChanges from '../accounting/AccountingChanges';
import DocumentAccountStatement from '../documents/DocumentAccountStatement';
import ReportDay from '../Reports/ReportDay';
import ReportDayHistory from '../Reports/ReportDayHistory';
import ReportDayEdit from '../Reports/ReportDayEdit';
import ReportDayView from '../Reports/ReportDayView';
import DocumentBitacoraReport from '../documents/DocumentBitacoraReport';
import GroupListLocal from '../groups/GroupListLocal';
import GroupListLocalNewCycle from '../groups/GroupListLocalNewCycle';
import AccountRegister from '../catalogsofaccounts/AccountRegister';
import AccountsList from '../catalogsofaccounts/AccountList';
import Account from '../catalogsofaccounts/Account';
import ListBranches from '../Branches/ListBranches';
import ListDisbursmentAndPayment from '../Policies/ListDisbursmentAndPayment';
import PoliciesList from '../Policies/PoliciesList';
import PolicyDetails from '../Policies/PolicyDetails';
import GroupListCreditsIndividual from '../groups/GroupListCreditsIndividual';
import GroupListPaymentCreditsIndividual from '../groups/GroupListPaymentCreditsIndividual';
import GroupListCreditsEmployee from '../groups/GroupListCreditsEmployee';
import GroupListPaymentCreditsEmployee from '../groups/GroupListPaymentCreditsEmployee';
import GroupRequisition from '../groups/GroupRequisition';

const routes = [];

try {
  routes.push({
    title: 'Escritorio',
    path: '/escritorio',
    exact: true,
    component: Home,
  });

  if (user.rol.es_administrador) {
    routes.push({
      path: '/solicitudes',
      exact: true,
      component: GroupRequisitions,
    });
  }

  // Documentos y pagos (agrupados por tipo de crédito)
  const creditTypes = [
    { base: '/grupos', component: Group },
    { base: '/creditos-individuales', component: Group },
    { base: '/creditos-empleados', component: Group },
  ];
  const docRoutes = [
    {
      suffix: '/:id_grupo/solicitud-actual/:id_solicitud_actual/control-pagos',
      component: DocumentPaymentControl,
    },
    {
      suffix: '/:id_grupo/solicitud-actual/:id_solicitud_actual/poliza',
      component: DocumentCheckPolicy,
    },
    {
      suffix: '/:id_grupo/solicitud-actual/:id_solicitud_actual/varios',
      component: DocumentVarius,
    },
    {
      suffix: '/:id_grupo/historial/:id_solicitud_actual/control-pagos',
      component: DocumentPaymentControl,
    },
    {
      suffix: '/:id_grupo/historial/:id_solicitud_actual/poliza',
      component: DocumentCheckPolicy,
    },
    {
      suffix: '/:id_grupo/historial/:id_solicitud_actual/varios',
      component: DocumentVarius,
    },
  ];
  creditTypes.forEach((type) => {
    docRoutes.forEach((route) => {
      routes.push({
        path: `${type.base}${route.suffix}`,
        exact: true,
        component: route.component,
      });
    });
  });

  // Permisos Socios
  if (
    !_.isEmpty(user.rol.permisos.Socios) &&
    user.rol.permisos.Socios.registrar
  ) {
    routes.push({
      title: 'Registro',
      path: '/clientas/registro',
      exact: true,
      component: PartnerRegister,
    });
  }
  if (
    !_.isEmpty(user.rol.permisos.Socios) &&
    user.rol.permisos.Socios.consultar
  ) {
    routes.push({
      title: 'Clientas',
      path: '/clientas',
      exact: true,
      component: PartnerList,
    });
    routes.push({
      title: 'Editar clienta',
      path: '/clientas/:id_diccionario/:id_socio/:id_en_sucursal',
      component: Partner,
    });
  }
  if (!_.isEmpty(user.rol.permisos.Validacion)) {
    routes.push({
      title: 'Validación',
      path: '/validacion',
      exact: true,
      component: PartnerListModeration,
    });
  }
  if (
    !_.isEmpty(user.rol.permisos.Validacion) &&
    user.rol.permisos.Validacion.editar
  ) {
    routes.push({
      title: 'Validar Clienta',
      path: '/validacion/:id_diccionario/:id_socio/:id_en_sucursal',
      component: Partner,
    });
  }

  // Grupos
  if (
    !_.isEmpty(user.rol.permisos.Grupos) &&
    user.rol.permisos.Grupos.consultar
  ) {
    routes.push({
      title: 'Grupos',
      path: '/grupos',
      exact: true,
      component: GroupList,
    });
    routes.push({
      title: 'Editar grupo',
      path: '/grupos/:id_diccionario/:id_grupo',
      component: Group,
    });
  }
  if (
    !_.isEmpty(user.rol.permisos.Grupos) &&
    user.rol.permisos.Grupos.listalocal
  ) {
    routes.push({
      title: 'Grupos por guardar',
      path: '/grupos/grupos-por-guardar',
      exact: true,
      component: GroupListLocal,
    });
  }
  if (
    !_.isEmpty(user.rol.permisos.Grupos) &&
    user.rol.permisos.Grupos.registrar
  ) {
    routes.push({
      title: 'Nuevo crédito',
      path: '/grupos/registro',
      exact: true,
      component: GroupRegister,
    });
    routes.push({
      title: 'Grupos documentos por guardar',
      path: '/grupos/documentos-por-guardar',
      exact: true,
      component: GroupListLocalNewCycle,
    });
  }
  if (!_.isEmpty(user.rol.permisos.Grupos) && user.rol.permisos.Grupos.wizard) {
    routes.push({
      title: 'Nuevo grupo',
      path: '/nuevo-grupo',
      exact: true,
      component: GroupRegisterWizard,
    });
    routes.push({
      title: 'Nuevo ciclo',
      path: '/nuevo-ciclo/:id_diccionario/:groupId',
      exact: true,
      component: GroupRegisterWizard,
    });
    routes.push({
      title: 'Nuevo grupo local',
      path: '/grupos/nuevo-grupo/:localGroupId',
      exact: true,
      component: GroupRegisterWizard,
    });
  }

  // Créditos Individuales
  if (
    !_.isEmpty(user.rol.permisos.CreditosIndividuales) &&
    user.rol.permisos.CreditosIndividuales.consultar
  ) {
    routes.push({
      title: 'Créditos Individuales',
      path: '/creditos-individuales',
      exact: true,
      component: GroupListCreditsIndividual,
    });
    routes.push({
      title: 'Crédito Individual',
      path: '/creditos-individuales/:id_grupo',
      component: Group,
    });
  }

  // Créditos Empleados (solo admin)
  if (user.rol.es_administrador === true) {
    routes.push({
      title: 'Créditos de empleados',
      path: '/creditos-empleados',
      exact: true,
      component: GroupListCreditsEmployee,
    });
    routes.push({
      title: 'Crédito de empleados',
      path: '/creditos-empleados/:id_grupo',
      component: Group,
    });
  }

  // Autorizaciones
  if (
    !_.isEmpty(user.rol.permisos.Autorizaciones) &&
    user.rol.permisos.Autorizaciones.consultar
  ) {
    routes.push({
      title: 'Autorizaciones',
      path: '/autorizaciones',
      exact: true,
      component: GroupListAutorization,
    });
    routes.push({
      title: 'Aprobar crédito',
      path: '/autorizaciones/:id_diccionario/:id_grupo/solicitud-actual/:id_solicitud',
      exact: true,
      component: GroupRequisition,
    });
  }

  // Autorizados
  if (
    !_.isEmpty(user.rol.permisos.Autorizados) &&
    user.rol.permisos.Autorizados.consultar
  ) {
    routes.push({
      title: 'Autorizados',
      path: '/autorizados',
      exact: true,
      component: GroupListAuthorized,
    });
    routes.push({
      title: 'Crédito autorizado',
      path: '/autorizados/:id_diccionario/:id_grupo/solicitud-actual/:id_solicitud',
      exact: true,
      component: GroupRequisition,
    });
  }

  // Verificaciones
  if (
    !_.isEmpty(user.rol.permisos.Verificaciones) &&
    user.rol.permisos.Verificaciones.consultar
  ) {
    routes.push({
      title: 'Verificaciones',
      path: '/verificaciones',
      exact: true,
      component: GroupListCheck,
    });
    routes.push({
      title: 'Verificaciones',
      path: '/verificaciones/:id_solicitud',
      component: GroupListCheckRequisition,
    });
  }

  // Pagos
  if (
    !_.isEmpty(user.rol.permisos.Pagos) &&
    user.rol.permisos.Pagos.consultar
  ) {
    routes.push({
      title: 'Pagos',
      path: '/pagos',
      exact: true,
      component: GroupListPayment,
    });
    routes.push({
      title: 'Pagos',
      path: '/pagos/:query',
      exact: true,
      component: GroupListPayment,
    });
    routes.push({
      path: '/pagos/estado-cuenta',
      exact: true,
      component: DocumentAccountStatement,
    });
    routes.push({
      path: '/pagos/edicion/:id_solicitud',
      exact: true,
      component: GroupRequisitionPayments,
    });
    routes.push({
      path: '/pagos/detalles-del-credito/:id_solicitud',
      exact: true,
      component: RequisitionDetails,
    });
  }

  // Pagos Créditos Individuales
  if (
    !_.isEmpty(user.rol.permisos.PagosCreditosIndividuales) &&
    user.rol.permisos.PagosCreditosIndividuales.consultar
  ) {
    routes.push({
      title: 'Pagos Créditos Individuales',
      path: '/pagos-creditos-individuales',
      exact: true,
      component: GroupListPaymentCreditsIndividual,
    });
    routes.push({
      path: '/pagos-creditos-individuales/estado-cuenta',
      exact: true,
      component: DocumentAccountStatement,
    });
    routes.push({
      path: '/pagos-creditos-individuales/edicion/:id_solicitud',
      exact: true,
      component: GroupRequisitionPayments,
    });
    routes.push({
      path: '/pagos-creditos-individuales/detalles-del-credito/:id_solicitud',
      exact: true,
      component: RequisitionDetails,
    });
  }

  // Pagos Créditos Empleados
  if (
    !_.isEmpty(user.rol.permisos.PagosCreditosEmpleados) &&
    user.rol.permisos.PagosCreditosEmpleados.consultar
  ) {
    routes.push({
      title: 'Pagos Créditos a Empleados',
      path: '/pagos-creditos-empleados',
      exact: true,
      component: GroupListPaymentCreditsEmployee,
    });
    routes.push({
      path: '/pagos-creditos-empleados/estado-cuenta',
      exact: true,
      component: DocumentAccountStatement,
    });
    routes.push({
      path: '/pagos-creditos-empleados/edicion/:id_solicitud',
      exact: true,
      component: GroupRequisitionPayments,
    });
    routes.push({
      path: '/pagos-creditos-empleados/detalles-del-credito/:id_solicitud',
      exact: true,
      component: RequisitionDetails,
    });
  }

  // Reportes y Bitácora
  if (
    !_.isEmpty(user.rol.permisos.Reportes) &&
    user.rol.permisos.Reportes.consultar
  ) {
    routes.push({
      title: 'Reportes',
      path: '/reportes',
      exact: true,
      component: GroupListPaymentReport,
    });
    routes.push({
      title: 'Bitácora',
      path: '/bitacora',
      exact: true,
      component: ReportDay,
    });
    routes.push({
      title: 'Historial de Bitácoras',
      path: '/bitacora/historial',
      exact: true,
      component: ReportDayHistory,
    });
    routes.push({
      title: 'Editar reporte de bitácora',
      path: '/bitacora/edicion/:id_bitacora',
      exact: true,
      component: ReportDayEdit,
    });
    routes.push({
      title: 'Detalles del reporte de bitácora',
      path: '/bitacora/visualizar/:id_bitacora',
      exact: true,
      component: ReportDayView,
    });
    routes.push({
      path: '/bitacora/historial/bitacora-reporte',
      exact: true,
      component: DocumentBitacoraReport,
    });
  }

  // Contabilidad
  if (
    !_.isEmpty(user.rol.permisos.Contabilidad) &&
    user.rol.permisos.Contabilidad.consultar
  ) {
    routes.push({
      title: 'Contabilidad',
      path: '/contabilidad',
      exact: true,
      component: AccountingChanges,
    });
    routes.push({
      title: 'Sucursales',
      path: '/sucursales',
      component: ListBranches,
    });
    routes.push({
      title: 'Pagos y Desembolsos',
      path: '/pagos&Desembolsos',
      component: ListDisbursmentAndPayment,
    });
    routes.push({
      title: 'Listado de pólizas',
      path: '/listaPolizas',
      component: PoliciesList,
    });
    routes.push({
      title: 'Detalles de póliza',
      path: '/polizaDetalles/:id_poliza/:num_poliza/:period_poliza',
      component: PolicyDetails,
    });
    routes.push({
      title: 'CatCuentas',
      path: '/catCuentas/registro',
      component: AccountRegister,
    });
    routes.push({
      title: 'CatCuentasList',
      path: '/catCuentas/list',
      component: AccountsList,
    });
    routes.push({
      title: 'Editar Cuenta',
      path: '/account/:id_account',
      component: Account,
    });
  }

  // Configuración (solo admin)
  if (user.rol.es_administrador === true) {
    routes.push({
      title: 'Configuración',
      path: '/configuracion',
      component: Configuration,
    });
  }

  // Catálogo de sucursales y registro de cambios
  routes.push({
    title: 'Sucursales',
    path: '/catalogo/sucursales',
    exact: true,
    component: BranchOffices,
  });
  routes.push({
    title: 'Registro de cambios',
    path: '/registro-cambios',
    exact: true,
    component: ChangeRecord,
  });

  // Empleados
  if (
    !_.isEmpty(user.rol.permisos.Empleados) &&
    user.rol.permisos.Empleados.registrar
  ) {
    routes.push({
      title: 'Nuevo empleado',
      path: '/empleados/registro',
      component: EmployeeRegister,
    });
  }
  if (
    !_.isEmpty(user.rol.permisos.Empleados) &&
    user.rol.permisos.Empleados.consultar
  ) {
    routes.push({
      title: 'Empleados',
      path: '/empleados',
      exact: true,
      component: EmployeeList,
    });
  }
  if (
    !_.isEmpty(user.rol.permisos.Empleados) &&
    user.rol.permisos.Empleados.consultar
  ) {
    routes.push({
      title: 'Editar empleado',
      path: '/empleados/:id_diccionario/:id_empleado',
      component: Employee,
    });
  }
} catch (error) {
  console.log('No se ha recuperado datos de usuario y de rol');
}

export default routes;
